export const ru = {
    bannersEdit: 'Редактирование объявлений',
    campaignsEdit: 'Редактирование кампаний',
    clientHistory: 'История изменений',
    clientsReports: 'Отчёт по клиентам',
    deals: 'Список сделок',
    domainsReports: 'Отчёт по доменам',
    freelancerCard: 'Специалист по Яндекс.Директу',
    freelancerCardEdit: 'Анкета специалиста',
    freelancerCustomers: 'Список заказчиков',
    freelancersList: 'Специалисты по настройке Яндекс.Директа',
    groupsEdit: 'Редактирование групп',
    manageInternal: 'Инструменты для ЦМ',
    marketerCard: 'Карточка маркетолога',
    marketers: 'Управление маркетологами',
    minusPhrasesLibrary: 'Библиотека минус-фраз',
    mobileAppsCreate: 'Добавить мобильное приложение',
    mobileAppsEdit: 'Просмотр приложения',
    mobileAppsList: 'Мобильные приложения',
    offlineReports: 'Офлайн отчеты',
    products: 'Управление продуктами',
    recommendationsItems: 'Рекомендации',
    recommendationsPage: 'Рекомендации',
    tools: 'Инструменты',
    welcome: 'Добро пожаловать в Яндекс Директ!'
};
